// src/components/csrf.js
// Função utilitária para buscar o token CSRF do backend Laravel

export async function getCsrfToken(apiBaseUrl = "http://localhost:8000") {
  try {
    const response = await fetch(`${apiBaseUrl}/csrf-token`, {
      credentials: 'include', // importante para cookies de sessão
    });
    if (!response.ok) throw new Error("Erro ao buscar CSRF token");
    const data = await response.json();
    // Espera-se que o backend retorne { csrfToken: '...' }
    return data.csrfToken || data.token || null;
  } catch (err) {
    return null;
  }
}
